import React from 'react'
import PropTypes from 'prop-types'
import { FlowRequestModalFooter, FlowRequestModalText } from './style'
import Button from '../Button'
import { FormattedMessage } from 'react-intl'

const WarnFlowRequestModal = ({ cancelHandler, text, rejectBtnText = 'cancel' }) => {

  return (
    <>
      <FlowRequestModalText data-testid='test-request-modal-text'>
        {text}
      </FlowRequestModalText>
      <FlowRequestModalFooter>
        <Button onClick={cancelHandler} type='secondary' dataTest='cancel'>
          <FormattedMessage id={rejectBtnText} />
        </Button>
      </FlowRequestModalFooter>
    </>
  )
}

WarnFlowRequestModal.propTypes = {
  cancelHandler: PropTypes.func.isRequired,
  text: PropTypes.node.isRequired,
  rejectBtnText: PropTypes.string
}

export default WarnFlowRequestModal
